import React from 'react'

export const SwitchComponente = ({texto, elCheck, name, datos, setDatos, tipo}) => {
  return (
    <div className='d-flex align-items-center justify-content-center text-break'>
        <input
            disabled={tipo}
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={tipo !== true ? elCheck : true}
            onChange={(e) => setDatos({...datos, [name]: e.target.checked})}
        />
        <label
            className="form-check-label text-secondary-light"
            style={{fontSize:'11px'}}
        >
            {texto}
        </label>
    </div>
  )
}
